import React from 'react';
import AddIcon from '@wix/da-ds/pkg/Icons/24x24/Add';
import GhostButton from '@wix/da-ds/pkg/Buttons/GhostButton';
import IconButtonWithBackground from '@wix/da-ds/pkg/Buttons/IconButton/IconButtonWithBackground';
import { useTranslation } from 'react-i18next';
import InnerMediaSelector from '../InnerMediaSelector';
import { useCurrentMediaSource } from '../../_hocs/withCurrentMediaSource';
import { MediaSourceType } from '../../types';
export const AddDeviationsButton = ({ disabled , limit , plusOnly , currentDeviationIds , isShowingAddDeviationsPopup , showAddDeviationsPopup , hideAddDeviationsPopup , addDeviations: addDeviationsAction  })=>{
    const { currentMediaSource  } = useCurrentMediaSource();
    const { t  } = useTranslation();
    const onSelect = (deviations)=>{
        addDeviationsAction(deviations);
        hideAddDeviationsPopup();
    };
    return /*#__PURE__*/ React.createElement(React.Fragment, null, plusOnly ? /*#__PURE__*/ React.createElement(IconButtonWithBackground, {
        size: "medium",
        icon: AddIcon,
        onClick: showAddDeviationsPopup,
        disabled: disabled
    }) : /*#__PURE__*/ React.createElement(GhostButton, {
        variant: "main",
        size: "large",
        onClick: showAddDeviationsPopup,
        disabled: disabled,
        icon: AddIcon
    }, t(currentMediaSource === MediaSourceType.TIER_POSTS ? 'mediapopup.addPosts' : 'mediapopup.addDeviations')), isShowingAddDeviationsPopup && /*#__PURE__*/ React.createElement(InnerMediaSelector, {
        onSelect: onSelect,
        onClose: hideAddDeviationsPopup,
        selectionLimit: limit,
        title: t(currentMediaSource === MediaSourceType.TIER_POSTS ? 'mediapopup.addPosts' : 'mediapopup.addDeviations'),
        submitBtnLabel: t('mediapopup.add'),
        ignoreDeviationIds: currentDeviationIds
    }));
};
AddDeviationsButton.displayName = 'AddDeviationsButton';
export default AddDeviationsButton;
